import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import withStyles from '@mui/styles/withStyles';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

// @mui/icons-material
import Check from '@mui/icons-material/Check';

// core components
import GridContainer from '../md/components/Grid/GridContainer.jsx';
import GridItem from '../md/components/Grid/GridItem.jsx';
import CustomInput from '../md/components/CustomInput/CustomInput.jsx';
import Card from '../md/components/Card/Card.jsx';
import CardHeader from '../md/components/Card/CardHeader.jsx';
import CardText from '../md/components/Card/CardText.jsx';
import CardBody from '../md/components/Card/CardBody.jsx';

import regularFormsStyle from '../assets/jss/crm/views/regularFormsStyle';

import KSelect from '../components/KSelect';
import CrmRadio from '../components/CrmRadio';

import { addDemo } from '../store/slices/accountsSlice';
import { setDemoToShow } from '../store/slices/intendedInfoSlice';

import { createStdRequest, apiFetch, generateRandomToken } from '../utils/utils';

import CrmTextField from '../components/CrmTextField';
import CrmButton from '../components/CrmButton';

const localStyles = {
  ...regularFormsStyle,
  textFieldHolder: {
    marginTop: '16px',
  },
  rightColumnSpacerDiv: {
    height: '144px',
  },
};

class LaunchDemoForm extends React.Component {
  randomToken = generateRandomToken(10);
  tokenForIndividualCallsCheckbox = 42;
  showPrefNameInMdStyle = true;

  constructor(props) {
    super(props);

    this.state = {
      redirectToDemoOverview: false,
      checked: [],
      suppressEmailDeconfliction: false,
      selectedComplexity: 'Normal',
      providerName: 'Acme Recovery ' + this.randomToken + ', Inc.',
      firstName: 'Florence',
      middleNames: '',
      lastName: 'Nightingale',
      preferredName: '',
      email: 'crmAdmin+' + this.randomToken + '@acmeRecovery.com',
      password: 'P@ssw0rd',
      confirmPassword: 'P@ssw0rd',
      scriptOptions: [],
      chosenScript: '',
    };
  }

  componentDidMount() {
    // const apiReturnJson = ["PlainAccount.xml", "StandardDemo.xml", "DemoScript.xml", "QuaieNewParadigm.xml"];
    // const scriptOptions = apiReturnJson.map(name => { return { value: name, label: name } });
    // this.setState({ scriptOptions });
    this.discoverAvailableScripts();
  }

  discoverAvailableScripts() {
    const uri = '/api/demo/availableScripts';
    const request = createStdRequest(uri);
    const actionOnGoodResponse = (json) => {
      this.setState({ scriptOptions: json, chosenScript: 'PlainAccount.xml' });
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  handleTextChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }

  handleComplexityChange(event) {
    this.setState({ selectedComplexity: event.target.value });
  }

  handleUseApiToggle(value) {}

  handleSuppressDeconflictionToggle(event) {
    this.setState({ suppressEmailDeconfliction: event.target.checked });
  }

  handleToggle(value) {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked,
    });
  }

  handleChosenScriptChange(newScript) {
    this.setState({ chosenScript: newScript });
  }

  createApiStruct() {
    const makeIndividualApiCalls = this.state.checked.indexOf(this.tokenForIndividualCallsCheckbox) >= 0;
    return {
      firstName: this.state.firstName.trim(),
      middleNames: this.state.middleNames.trim(),
      lastName: this.state.lastName.trim(),
      preferredName: this.state.preferredName.trim(),
      email: this.state.email.trim(),
      password: this.state.password.trim(),
      firmName: this.state.providerName.trim(),
      salesLine: '+12063319150',
      scriptName: this.state.chosenScript,
      suppressEmailDeconfliction: this.state.suppressEmailDeconfliction,
      makeIndividualApiCalls: makeIndividualApiCalls,
      complexity: this.state.selectedComplexity,
    };
  }

  handleSubmit() {
    const apiStruct = this.createApiStruct();
    const uri = '/api/Demo/Launch';
    const request = createStdRequest(uri, 'POST', apiStruct);
    const actionOnGoodResponse = (json) => {
      const { success, demoDescrip, errorCode } = json;
      if (success) {
        this.props.setDemoToShow(demoDescrip.demoId);
        this.props.addDemo(demoDescrip);
        this.setState({ redirectToDemoOverview: true });
      } else {
        switch (errorCode) {
          case 1:
            this.setState({ errorMessage: 'Failed to create Person for admin in DB' });
            break;
          case 2:
            this.setState({ errorMessage: 'Failed to create Firm in DB' });
            break;
          case 3:
            this.setState({ errorMessage: 'System failed to create ApplicationUser in DB' });
            break;
          default:
            this.setState({ errorMessage: 'Unknown launch error. Error code: ' + errorCode });
            break;
        }
      }
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  render() {
    if (this.state.redirectToDemoOverview) {
      return <Redirect to="demo" push />;
    }

    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="allevaOrange" text>
              <CardText color="allevaOrange">
                <h4 className={classes.cardTitle}>Launch Demo</h4>
              </CardText>
              <h4 className={classes.cardIconTitle}>
                Define an imaginary Provider Firm and a User who will serve as the Admin for that Firm.
              </h4>
            </CardHeader>
            <CardBody>
              <form>
                <CrmTextField
                  label="Provider Name"
                  id="providerName"
                  fullWidth
                  value={this.state.providerName}
                  onChange={(event) => this.handleTextChange(event)}
                />
                <h4 className={classes.cardIconTitle}>Admin for the Provider</h4>
                <GridContainer>
                  <GridItem xs={12} sm={6}>
                    <div className={classes.textFieldHolder}>
                      <CrmTextField
                        label="First Name"
                        id="firstName"
                        required
                        fullWidth
                        value={this.state.firstName}
                        onChange={(event) => this.handleTextChange(event)}
                      />
                    </div>
                    <div className={classes.textFieldHolder}>
                      <CrmTextField
                        label="Middle Name(s)"
                        id="middleNames"
                        fullWidth
                        value={this.state.middleNames}
                        onChange={(event) => this.handleTextChange(event)}
                      />
                    </div>
                    <div className={classes.textFieldHolder}>
                      <CrmTextField
                        label="Last Name"
                        id="lastName"
                        required
                        fullWidth
                        value={this.state.lastName}
                        onChange={(event) => this.handleTextChange(event)}
                      />
                    </div>
                    {this.showPrefNameInMdStyle ? (
                      <CustomInput
                        labelText="Preferred Name"
                        id="preferredName"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: 'text',
                          value: this.state.preferredName,
                          onChange: (event) => this.handleTextChange(event),
                        }}
                      />
                    ) : (
                      <div className={classes.textFieldHolder}>
                        <CrmTextField
                          label="Preferred Name"
                          id="preferredName"
                          fullWidth
                          value={this.state.preferredName}
                          onChange={(event) => this.handleTextChange(event)}
                        />
                      </div>
                    )}
                  </GridItem>
                  <GridItem xs={12} sm={6}>
                    <div className={classes.textFieldHolder}>
                      <CrmTextField label="Email Address" fullWidth readOnly disabled value={this.state.email} />
                    </div>
                    <div className={classes.rightColumnSpacerDiv} />
                    <div style={{ marginTop: '16px' }}>
                      <KSelect
                        fullWidth
                        label="Script to run"
                        liveOptions={this.state.scriptOptions}
                        value={this.state.chosenScript}
                        onChange={(event) => this.handleChosenScriptChange(event.target.value)}
                      />
                    </div>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={6} sm={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          tabIndex={-1}
                          onClick={() => this.handleToggle(this.tokenForIndividualCallsCheckbox)}
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot,
                          }}
                        />
                      }
                      classes={{
                        label: classes.label,
                      }}
                      label="Simulate History by making individual API calls"
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onClick={(event) => this.handleSuppressDeconflictionToggle(event)}
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot,
                          }}
                        />
                      }
                      classes={{
                        label: classes.label,
                      }}
                      label="Suppress Email Deconfliction (NB: Only Kim should use this!!)"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={2}>
                    <FormLabel className={classes.labelHorizontal + ' ' + classes.labelHorizontalRadioCheckbox}>
                      Choose UI complexity
                    </FormLabel>
                  </GridItem>
                  <GridItem xs={12} sm={10}>
                    <div className={classes.inlineChecks}>
                      <FormControlLabel
                        control={
                          <CrmRadio
                            checked={this.state.selectedComplexity === 'Normal'}
                            onChange={(event) => this.handleComplexityChange(event)}
                            value="Normal"
                            name="complexityRadio"
                          />
                        }
                        classes={{
                          label: classes.label,
                        }}
                        label="Normal"
                      />
                      <FormControlLabel
                        control={
                          <CrmRadio
                            checked={this.state.selectedComplexity === 'Blank'}
                            onChange={(event) => this.handleComplexityChange(event)}
                            value="Blank"
                            name="complexityRadio"
                          />
                        }
                        classes={{
                          label: classes.label,
                        }}
                        label="Blank UI Lists"
                      />
                      <FormControlLabel
                        control={
                          <CrmRadio
                            checked={this.state.selectedComplexity === 'Single'}
                            onChange={this.handleChange}
                            value="Single"
                            name="complexityRadio"
                          />
                        }
                        classes={{
                          label: classes.label,
                        }}
                        label="Single-item UI Lists"
                      />
                    </div>
                  </GridItem>
                </GridContainer>
                <GridContainer justifyContent="flex-end">
                  <GridItem xs={12} sm={12} md={12}>
                    <CrmButton filled onClick={() => this.handleSubmit()}>
                      Launch
                    </CrmButton>
                  </GridItem>
                </GridContainer>
              </form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default connect(null, { addDemo, setDemoToShow })(withStyles(localStyles)(LaunchDemoForm));
